import DevolucaoMaterialNovo from './DevolucaoMaterialNovo';

export default DevolucaoMaterialNovo;